














import Vue from 'vue'

export default Vue.extend({
  name: 'Partner',
  data() {
    return {
      referenceList: [
        { uid: `1`, local: `/asset/partner/futurice.svg`, path: `https://futurice.com`, description: `futurice` },
        { uid: `3`, local: `/asset/partner/columbiaroad.png`, path: `https://columbiaroad.com`, description: `columbia road` },
        // { uid: `5`, local: `/asset/partner/telia.png`, path: `https://telia.fi`, description: `telia` },
        { uid: `7`, local: `/asset/partner/speechly.png`, path: `https://speechly.com`, description: `speechly` },
        { uid: `9`, local: `/asset/partner/pockethunt.svg`, path: `https://pockethunt.com`, description: `pockethunt` }
      ]
    }
  }
})
